<ng-container [formGroup]="formGroup">

  <mat-form-field class="flex-form" appearance="{{appearance}}" >
    @if (!labelAsObs) {
      <mat-label>{{label | translate}} </mat-label>
    }
    @if (labelAsObs) {
      <mat-label>{{labelAsObs | async}} </mat-label>
    }
    <input [maxLength]="maxLength" [matAutocomplete]="autoComplete" [formControlName]="autocompleteControlName" matInput [id]="id ? id: autocompleteControlName"
      [readonly]="!canFilterItems"
      type="text">
    @if (required && formGroup.get(autocompleteControlName)?.errors?.required) {
      <mat-error>
        {{errorRequiredMessage | translate}}
      </mat-error>
    }
    @if (customErrorKey && formGroup.get(autocompleteControlName)?.errors && formGroup.get(autocompleteControlName)?.errors[customErrorKey]) {
      <mat-error>
        {{customErrorMessage | translate}}
      </mat-error>
    }

    @if (inactive) {
      <mat-hint [ngStyle]="{color: '#ff0000'}">{{ inactiveMessage | translate}}</mat-hint>
    }
    @if (showNoMatchFound && noMatchFound) {
      <mat-hint [ngStyle]="{color: '#ff0000'}">{{ noMatchFoundMessage | translate}}</mat-hint>
    }

  </mat-form-field>

  <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayItemField.bind(this)">
    @if (isLoading) {
      <mat-option class="is-loading">
        <mat-spinner diameter="50"></mat-spinner>
      </mat-option>
    }
    @if (!isLoading) {
      @for (item of filteredValues; track item) {
        <mat-option  (onSelectionChange)="onItemSelectedInternal(item)" [value]="item[displayField]" [matTooltip]="showOptionTooltips ? displayFunction(item): ''">
          {{ displayFunction(item) }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</ng-container>
